// Time-based throttled task runner

export const A_TICK = Math.round(1000 / 60); // indicate a frame in ms

/**
 * This is a **debouncing** utility like `@debounced`.
 *
 * Use `@throttled` for throttling
 */
export class DebouncedTaskRunner {
  readonly intervalMs: number;
  token: ReturnType<typeof setTimeout> | null = null;

  constructor(intervalMs: number) {
    this.intervalMs = intervalMs;
  }

  enqueue(callback) {
    if (this.token) {
      clearTimeout(this.token);
    }

    if (process.env.NODE_ENV === "test") {
      callback();
    } else {
      this.token = setTimeout(callback, this.intervalMs);
    }
  }

  // should be called in componentDidUnmount()
  clear() {
    if (this.token) {
      clearTimeout(this.token);
      this.token = null;
    }
  }
}
